import { render, staticRenderFns } from "./tail-list.vue?vue&type=template&id=7a17e422&scoped=true&"
import script from "./tail-list.vue?vue&type=script&lang=js&"
export * from "./tail-list.vue?vue&type=script&lang=js&"
import style0 from "./tail-list.vue?vue&type=style&index=0&id=7a17e422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a17e422",
  null
  
)

export default component.exports